// removed by extract-text-webpack-plugin
module.exports = {"container":"_2SSNwlUHkJTIVIdmk_JrRV_0","hero":"_2rMGlCLOECDQ2i4h9FwjNv_0","image":"_3d4uCJSStIJZ3UubxlclZb_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1cdccb9d","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CampHero.vue
// module id = CWhg
// module chunks = 30